<template>

<com-item name="game.peers.duration" :size="size" :loading="loading" :is-empty="!active" title="Ownership Duration">

	<template v-slot:about>

		<p>How long people keep this game.</p>

	</template>

	<template v-slot:stats>

		<app-visualisation-bars :data="graph" />

	</template>

</com-item>

</template>

<script>

import comItem from './../common/Item'

export default {

	props: ['fetching', 'your', 'you', 'size'],

	components: {
		'com-item': comItem
	},

	data: function() {

		return {
			graph: {
				datasets: [
					{ type: 'bar', data: [], backgroundColor: '#4881bb', tooltip: '{{value}} user{{value.plural}} <small>{{x.label}}</small>' }
				],
				axis: {
					x: { labels: [], long: true },
					y: { min: 10, points: 10 }
				}
			}
		}

	},

	computed: {

		loading: function() { return this.fetching === 'all' },

		data: function() { return this.$store.getters['page/insights/game/peers'] },

		active: function() { return this.data && !this.loading && this.data.durationDistribution && this.data.durationDistribution.length }

	},

	created: function() { this.visualise() },

	watch: { data: function() { this.visualise() } },

	methods: {

		visualise: function() {

			if (!this.data || !this.data.durationDistribution) return

			this.graph.datasets[0].data = []
			this.graph.axis.x.labels = []

			this.data.durationDistribution.forEach(function(item) {

				this.graph.datasets[0].data.push(item.count)
				this.graph.axis.x.labels.push({ label: item.label })

			}.bind(this))

		}

	}

}

</script>

<style scoped>
</style>
